import React, { useEffect, useState } from 'react'
import CustomModal from '../../components/ReactModal'
import Modal from '../../components/Modal'
import { userService, bankService, subscriptionService } from '../../_services'
import { toast } from 'react-toastify'
import { saveData } from '../../_helpers'
import { FaTrash } from 'react-icons/fa'
import { MdModeEdit } from 'react-icons/md'
import AlertBox from '../AlertBox'
import { useHistory, Link } from 'react-router-dom'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { AddBankCardForm } from './AddBankCardForm'
import { Card } from './Card'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { BankForm } from './BankForm'
import { BankAccountCard } from './BankAccountCard'
import { cancelView, statusDescriptionView, statusView } from './utils'
import BankVerification from './BankAccountVerification'
dayjs.extend(utc);
dayjs.extend(timezone);


function PaymentMethod() {
    const bankSources = process.env.REACT_APP_BANK_SOURCES == 'true'
    
    const [addedAccount, setAddedAccount] = useState([])
    const [cardList, setCardList] = useState([])
    const [subscriptionInfo, setSubscriptionInfo] = useState(null)
    const [subscriptionTimezone, setSubscriptionTimezone] = useState(null)

    const [subscriptionStatus, setSubscriptionStatus] = useState(subscriptionInfo?.status)


    const [bankListRefreshkey, setbankListRefreshkey] = useState(0)
    const [addPayout, setAddPayout] = useState(false)
    const [addCard, setAddCard] = useState(false)
    const [host, setDetail] = useState({})
    const [refreshKey, setRefreshKey] = useState(0)
    const [suspense, setSuspense] = useState(true)
    const [isStripeVerified, setIsStripeVerified] = useState(false)
    const [stripeAllAccountDetails, setStripeAllAccountDetails] = useState({})
    const [currentStripeStatus, setCurrentStripeStatus] = useState(false)
    const [showUpdateVerificationDetailButton, setShowUpdateVerificationDetailButton] = useState(false)
    const history = useHistory()

    const [primarySource, setPrimarySource] = useState(null)

    const [addBankAccountEnabled, setAddBankAccountEnabled] = useState(false)

    const cancelSubscriptionAction = async () => {
        const res = await subscriptionService.updateSubscription(subscriptionInfo.planId, 'cancel')
        if(res.status) {
          setSubscriptionInfo(res.data)
          toast.success(res.message)
        } else {
          toast.error(res.message)
        }
      }

    function connect_account() {
      history.push('/settings/account_connect')
    }

    const fetchUserDetail = () => {
        userService.getDetail({}).then(objS => {
            if (objS.status) {
                setDetail(objS.data)
            }
        })
    }

    useEffect(() => {
        if (refreshKey !== 0) {
            fetchUserDetail()
        }
    }, [refreshKey])

    useEffect(() => {
        fetchUserDetail()
    }, [])

    useEffect(() => {
        const fetchStripeDetail = async () => {
            try {
                const res = await bankService.getStripeDetail()
                // When the host hasn't linked/created a Stripe account yet, the
                // backend responds with an error (status:false) and no `data`.
                // Treat that as an unverified account so the "Add Verification
                // Details" flow is shown instead of crashing the page.
                const stripeDetails = (res && res.status && res.data) ? res.data : {
                    business_type: null,
                    charges_enabled: false,
                    payouts_enabled: false,
                }

                if (stripeDetails.business_type !== null) {
                    const accountTypeIndividual = stripeDetails.business_type === 'individual'
                    const verficationStatus = accountTypeIndividual
                        ? stripeDetails.individual?.verification?.status
                        : stripeDetails.company?.verification?.status
                    setCurrentStripeStatus(verficationStatus)
                }
                const status = stripeDetails.charges_enabled && stripeDetails.payouts_enabled
                setIsStripeVerified(status)
                setStripeAllAccountDetails(stripeDetails)

                if (stripeDetails.requirements) {
                    const currently_due = stripeDetails.requirements.currently_due.filter(item => item !== 'external_account')

                    if (currently_due.length > 0 && stripeDetails.business_type) {
                        setShowUpdateVerificationDetailButton(true)
                    }
                }
            } catch (error) {
                console.error('getStripeDetail', error)
                setStripeAllAccountDetails({
                    business_type: null,
                    charges_enabled: false,
                    payouts_enabled: false,
                })
            } finally {
                setSuspense(false)
            }
        }
        fetchStripeDetail()
    }, [])

    useEffect(() => {
        const enabled = stripeAllAccountDetails.business_type !== null &&
            stripeAllAccountDetails.charges_enabled === true &&
            stripeAllAccountDetails.payouts_enabled === true

        setAddBankAccountEnabled(enabled)
    }, [stripeAllAccountDetails])


    useEffect(() => {
        const fetchAccountList = async () => {
            try {
                const res = await subscriptionService.getSources(true)
                if (res.status) {
                    const addedAccounts = res.data?.bankAccounts?.data
                    const cardList = res.data?.cardlist?.data
                    const subscriptionInfo = res.data.subscription

                    if(subscriptionInfo.primaryMethod) {
                        const primaryBank = addedAccounts?.find(value => {
                            return value.id == subscriptionInfo.primaryMethod
                        })
                        const primaryCard = cardList.find(value => {
                            return value.id == subscriptionInfo.primaryMethod
                        })

                        if(primaryBank) {
                            setPrimarySource({
                                type: 'bank',
                                value: primaryBank
                            })
                        }
                        if(primaryCard) {
                            setPrimarySource({
                                type: 'card',
                                value: primaryCard
                            })
                        }
                    }

                    setAddedAccount(addedAccounts)
                    setCardList(cardList)
                    setSubscriptionInfo(subscriptionInfo)
                    setSubscriptionTimezone(res.data.timezone)
                } else {
                    toast.error(res.message)
                    setAddedAccount([])
                    setCardList([])
                    setSubscriptionInfo(null)
                    setPrimarySource(null)
                }
            } catch (error) {
                toast.error('Something went wrong')
            }
        }

        fetchAccountList()
    }, [bankListRefreshkey])

    useEffect(() => {
        setSubscriptionStatus(subscriptionInfo?.status)
    }, [subscriptionInfo])

    const toggleAddPayout = () => {
        setAddPayout(e => !e)
    }

    const saveBankAccount = (accountForm, setRequesting) => {
        accountForm.accountHolderName = accountForm.accountHolderName.trim()
        accountForm.accountNumber = accountForm.accountNumber.trim()
        accountForm.confirmAccountNumber = accountForm.confirmAccountNumber.trim()
        accountForm.routingNumber = accountForm.routingNumber.trim()
        if (accountForm.accountNumber != accountForm.confirmAccountNumber) {
            toast.info('Account number and confirm account number must be same.')
            return
        }
        setRequesting(true)
        var postObj = { hostId: host.id, isPayment: true, ...accountForm }

        bankService.addBank(postObj).then(
            objS => {
                if (objS.status) {
                    setbankListRefreshkey(e => e + 1)
                    host.payoutVerification = true
                    saveData(host)
                    setAddPayout(false)
                    toast.success('Bank account added successfully')
                    setRefreshKey(oldKey => oldKey + 1)
                } else {
                    toast.error(objS.message)
                }
                setRefreshKey(e => e + 1)
                setRequesting(false)
            },
            error => {
                setRequesting(false)
            }
        )
    }

    const handleDelete = async id => {
        try {
            const res = await subscriptionService.handleDeleteBank(id)

            if (res.status) {
                toast.success(res.message)
                setAddedAccount(el => el.filter(curr => curr.id !== id))
                setbankListRefreshkey(oldKey => oldKey + 1)
            } else toast.error(res.message)
        } catch (error) {
            toast.error('Something went wrong!')
        }
    }

    return (
        <>
            {suspense ? (
                <div className="tw-flex tw-mt-8">
                    <p className="tw-text-center tw-py-4">Loading...</p>
                </div>
            ) : (
                <div className='tw-mt-8'>
                    <div className="tw-flex">
                        <div className="tw-text-sm tw-font-medium">
                            <div className='tw-mb-4'>
                                {stripeAllAccountDetails.business_type === null &&
                                    stripeAllAccountDetails.charges_enabled === false &&
                                    stripeAllAccountDetails.payouts_enabled === false && (
                                        <button
                                            disabled={currentStripeStatus === 'pending'}
                                            onClick={connect_account}
                                            className="btn btn-primary btn-sm tw-w-max"
                                        >
                                            {currentStripeStatus === 'pending' ? 'Under Review...' : 'Add Verification Details'}
                                        </button>
                                    )}
                                {showUpdateVerificationDetailButton && (
                                    <button onClick={connect_account} className="btn btn-primary btn-sm tw-w-max">
                                        {'Update Verification Details'}
                                    </button>
                                )}
                            </div>
                            <p className="tw-mb-2 tw-text-lg">Account Status</p>
                            <div id={subscriptionStatus}>
                                <div className="tw-mb-2 tw-flex tw-flex-row tw-items-center tw-gap-6">
                                    <div>
                                        {statusView(subscriptionStatus, subscriptionInfo?.processing)}
                                    </div>
                                    <div>
                                        {cancelView(subscriptionStatus, subscriptionInfo?.cancelOnNextRenew, cancelSubscriptionAction)}
                                    </div>
                                </div>
                                <div>
                                    {statusDescriptionView(subscriptionStatus, subscriptionInfo?.nextRenewDate, subscriptionInfo?.endOfGracePeriod, subscriptionInfo?.processing, subscriptionInfo?.cancelOnNextRenew, subscriptionTimezone)}
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div className="tw-max-w-md">
                        <div className='tw-flex tw-flex-col tw-w-full'>
                            <div className='tw-flex tw-flex-row tw-gap-2'>
                                {bankSources && <button disabled={!addBankAccountEnabled} onClick={() => setAddPayout(!addPayout)} className="btn btn-primary btn-sm tw-w-max mt-4">
                                    {/* Add bank account */}
                                    Add Bank Account
                                </button>}
                                <button onClick={() => setAddCard(!addCard)} className="btn btn-primary btn-sm tw-w-max mt-4">
                                    {/* Add bank account */}
                                    Add Credit Card
                                </button>
                            </div>
                            {bankSources && !addBankAccountEnabled && <p className="tw-text-sm tw-text-gray-400 tw-mt-1">
                                    ⓘ To add a bank account, complete verification.
                            </p>}
                            <div className='tw-mt-4'/>
                            {primarySource != null && 
                                ((bankSources && primarySource.type == 'bank') ? 
                                    <BankAccountCard
                                        isLast={addedAccount.length === 1}
                                        setbankListRefreshkey={setbankListRefreshkey}
                                        handleDelete={handleDelete}
                                        accountData={primarySource.value}
                                        key={primarySource.value.id}
                                        primaryId={subscriptionInfo?.primaryMethod}
                                        setSubscriptionInfo={setSubscriptionInfo}
                                    /> : 
                                ( primarySource.type == 'card' ?
                                    <Card key={primarySource.value.id} 
                                        setRefreshKey={(e) => {
                                            setRefreshKey(e)
                                            setbankListRefreshkey(e)
                                        }}
                                        data={primarySource.value}
                                        primaryId={subscriptionInfo?.primaryMethod}
                                        subscriptionInfo={subscriptionInfo}
                                        setSubscriptionInfo={setSubscriptionInfo}/> :
                                    <></>))
                            }
                            {bankSources && addedAccount.filter((value) => {return value.id != primarySource?.value?.id}).map(account => (
                                <BankAccountCard
                                    isLast={addedAccount.length === 1}
                                    setbankListRefreshkey={setbankListRefreshkey}
                                    handleDelete={handleDelete}
                                    accountData={account}
                                    key={account.id}
                                    primaryId={subscriptionInfo?.primaryMethod}
                                    setSubscriptionInfo={setSubscriptionInfo}
                                />
                            ))}
                            {cardList.filter((value) => {return value.id != primarySource?.value?.id}).map((curr) => {
                                return <Card key={curr.id} setRefreshKey={(e) => {
                                    setRefreshKey(e)
                                    setbankListRefreshkey(e)
                                }} data={curr} primaryId={subscriptionInfo?.primaryMethod}  subscriptionInfo={subscriptionInfo} setSubscriptionInfo={setSubscriptionInfo}/>
                            })}
                        </div>
                            
                    </div>
                    {addPayout && (
                        <CustomModal>
                            <div className='tw-flex tw-w-full tw-justify-center'>
                             <BankVerification onVerificationComplete={() => {
                                setbankListRefreshkey(e => e + 1)
                             }} onClose={() => {
                                setAddPayout(false)
                             }}/>
                             </div>
                            {/* <BankForm onSubmit={saveBankAccount} onClose={toggleAddPayout} /> */}
                        </CustomModal>
                    )}
                    {addCard && (
                        <Modal className="tw-rounded-2xl tw-w-full lg:tw-w-8/12 tw-mx-auto">
                            <AddBankCardForm onClose={() => {setAddCard(false)}} setRefreshKey={(e) => {
                                                setRefreshKey(e)
                                                setbankListRefreshkey(e)
                                            }}/>
                        </Modal>
                    )}
                </div>
            )}
        </>
    )
}

export default PaymentMethod
